export default __webpack_public_path__ + "static/media/face.132eef90.png";